import { render, staticRenderFns } from "./EditarItem.vue?vue&type=template&id=3eb0c528&scoped=true"
import script from "./EditarItem.vue?vue&type=script&lang=js"
export * from "./EditarItem.vue?vue&type=script&lang=js"
import style0 from "./EditarItem.vue?vue&type=style&index=0&id=3eb0c528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb0c528",
  null
  
)

export default component.exports